import { currencyCodes, CurrencyCode } from './constants';

const CURRENCY_CODES = new Set<string>(Object.values(CurrencyCode));

export function isCurrencyCode(value?: string): value is CurrencyCode {
  return value !== undefined && CURRENCY_CODES.has(value);
}

export function toCurrencyCode(value?: string): CurrencyCode {
  return isCurrencyCode(value) ? value : CurrencyCode.GBP;
}

export function getCurrencySymbolFromCountry(country?: string) {
  const lowercaseCountry = country?.toLowerCase();
  if (lowercaseCountry === 'au') {
    return 'A$';
  }
  if (
    lowercaseCountry === 'de' ||
    lowercaseCountry === 'fr' ||
    lowercaseCountry === 'it' ||
    lowercaseCountry === 'ie'
  ) {
    return '€';
  }
  if (lowercaseCountry === 'us') {
    return 'US$';
  }

  if (lowercaseCountry === 'ca') {
    return 'CA$';
  }
  if (lowercaseCountry === 'nz') {
    return 'NZ$';
  }
  return '£';
}

export function getCurrencySymbolFromCurrencyCode(currencyCode?: CurrencyCode) {
  switch (currencyCode) {
    case CurrencyCode.AUD: {
      return 'A$';
    }
    case CurrencyCode.EUR: {
      return '€';
    }
    case CurrencyCode.USD: {
      return 'US$';
    }
    case CurrencyCode.BRL: {
      return 'R$';
    }
    case CurrencyCode.CAD: {
      return 'CA$';
    }
    case CurrencyCode.CZK: {
      return 'CZK';
    }
    case CurrencyCode.DKK: {
      return 'DKK';
    }
    case CurrencyCode.HKD: {
      return 'HK$';
    }
    case CurrencyCode.HUF: {
      return 'HUF';
    }
    case CurrencyCode.ILS: {
      return '₪';
    }
    case CurrencyCode.JPY: {
      return 'JP¥';
    }
    case CurrencyCode.MYR: {
      return 'MYR';
    }
    case CurrencyCode.MXN: {
      return 'MX$';
    }
    case CurrencyCode.TWD: {
      return 'NT$';
    }
    case CurrencyCode.NZD: {
      return 'NZ$';
    }
    case CurrencyCode.NOK: {
      return 'NOK';
    }
    case CurrencyCode.PHP: {
      return 'PHP';
    }
    case CurrencyCode.PLN: {
      return 'PLN';
    }
    case CurrencyCode.RUB: {
      return 'RUB';
    }
    case CurrencyCode.SGD: {
      return 'SGD';
    }
    case CurrencyCode.SEK: {
      return 'SEK';
    }
    case CurrencyCode.CHF: {
      return 'CHF';
    }
    case CurrencyCode.THB: {
      return 'THB';
    }
    case CurrencyCode.TRY: {
      return 'TRY';
    }
    default: {
      return '£';
    }
  }
}

export function getCurrencyCodeFromCountryCode(countryCode: string) {
  const capitalisedCountryCode = countryCode.toUpperCase();
  if (!currencyCodes[capitalisedCountryCode]) {
    return CurrencyCode.GBP;
  }
  return currencyCodes[capitalisedCountryCode];
}
